import React from 'react';
import "./RunningChats.css";
import ImActiveIcon from "../../../media/images/ImActiveIcon.mjs";
import TextLabel from "../../../Controls/TextLabel.mjs";
import UserAvatar from "../../../Controls/UserAvatar.mjs";
import appLib from "../../../libs/appLib.mjs";

const G = window.glob;

const RunningChats = class extends React.Component {
	constructor(props) {
		super(props);
		this.uid = G.generateUid('RunningChats');
	}
	render() {
		// console.log(this.props);
		const lu = this.props.chatlist?.lastupdate ?? {};
		const keys = Object.keys( this.props.chatlist?.data ?? {})
			.sort( (a,b) => (lu[a] < lu[b] ? 1 : -1));
		return(
			<div className={"RunningChats"} id={this.uid}>
				<div className={"box-title"}>
					<ImActiveIcon/>
					<span>
						<TextLabel value={"ImActive"}/>
					</span>
				</div>
				<div className={"box-wrap"}>
					<div className={"ChatList"}>
						{ keys.length ? keys.map( k => {
							const c = this.props.chatlist.data[k];
							const group = k.startsWith("group:");
							const id = group ? k.replace(/^group:/, "") : k;
							const n = group ? appLib.group2name(id) : appLib.player2name(id);
							const icon = group ? appLib.group2icon(id) : appLib.player2icon(id);
							return (
								<div
									onClick={ ()=> { this.props.openChat(k) } }
									key={ k + this.props.chatlist.lastupdate[k] }
									className={
										"ChatListItem" +
										( this.props.unread[k] ? ' showNotificationBullet' : '')
									}
								>
									<div>
										<UserAvatar
											name={ n }
											icon={ icon }
											small={true}
											group={group}
										/>
									</div>
									<div>
										<p>{n}</p>
										<small>
											<TextLabel value={"Messages"} />: { c.length }
										</small>
									</div>
								</div>
							);
						}) : (
							<p className={"error"}>
								<TextLabel value={"No active chats"} />
							</p>
						)}
					</div>
				</div>
			</div>
		)
	}
}

export default RunningChats;